"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ListItemLink = _ref => {
  let {
    onClick,
    href,
    rel: _rel,
    ...props
  } = _ref;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const offSite = href && href.match(/^https?:\/\//);
  const rel = (_rel + (offSite ? ' noopener noreferrer' : '')).trim();
  const handleClick = async event => {
    const result = await (onClick === null || onClick === void 0 ? void 0 : onClick(event));
    if (href && !offSite) {
      event.preventDefault();
      navigate(href);
    }
    return result;
  };
  return /*#__PURE__*/_react.default.createElement(_material.ListItemButton, _extends({
    href: href,
    rel: rel === '' ? undefined : rel
  }, props, {
    onClick: handleClick
  }));
};
ListItemLink.defaultProps = {
  rel: '',
  component: 'a'
};
var _default = exports.default = ListItemLink;